import { makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'

export const usePainterJobCardStyles = makeStyles<Theme>((theme) => ({
  eventListSection: {
    flex: 1,
    overflowY: 'auto',
    backgroundColor: theme.palette.background.default,
    borderTop: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1.5, 2, 2)
  },
  dateHeading: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
    textAlign: 'center',
    marginBottom: theme.spacing(1.5)
  },
  emptyDay: {
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
    textAlign: 'center',
    padding: theme.spacing(3, 0)
  },
  jobCardWrapper: { marginBottom: theme.spacing(1) },
  jobCardTop: {
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.borderRadius.md,
    padding: theme.spacing(2),
    overflow: 'visible'
  },
  jobCardTopExpanded: {
    borderRadius: '4px 4px 0 0'
  },
  jobCardHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(0.25)
  },
  jobTitle: {
    ...theme.typography.h4,
    fontWeight: theme.typography.fontWeightMedium
  },
  jobExpandBtn: {
    padding: 0,
    color: theme.palette.text.secondary
  },
  jobDate: {
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2)
  },
  jobCardBottom: {
    backgroundColor: theme.palette.common.white,
    borderLeft: `1px solid ${theme.palette.divider}`,
    borderRight: `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderRadius: '0 0 4px 4px',
    padding: theme.spacing(2),
    paddingTop: theme.spacing(1),
    overflow: 'hidden'
  },
  actionRow: { display: 'flex', gap: theme.spacing(1) },
  addActionAnchor: {
    flex: 1,
    display: 'flex'
  },
  actionBtn: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 40,
    borderRadius: theme.borderRadius.md,
    backgroundColor: theme.paintscout.palette.brand.Neutral.P50,
    cursor: 'pointer',
    border: 'none'
  },
  actionBtnDisabled: {
    backgroundColor: theme.paintscout.palette.brand.Neutral.P80,
    cursor: 'default',
    opacity: 0.6
  },
  actionBtnIcon: { fontSize: 20, color: theme.palette.common.white },
  addActionMenu: {
    width: 250,
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.borderRadius.sm,
    boxShadow: theme.shadows[2],
    overflow: 'hidden'
  },
  addActionMenuItem: {
    ...theme.typography.body1,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    width: '100%',
    minHeight: 48,
    padding: theme.spacing(0, 2),
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.common.white,
    border: 'none',
    borderBottom: `1px solid ${theme.palette.divider}`,
    cursor: 'pointer',
    textAlign: 'left',
    '&:last-child': { borderBottom: 'none' },
    '&:hover': { backgroundColor: theme.palette.action.hover }
  },
  addActionMenuItemDisabled: {
    pointerEvents: 'none',
    color: theme.palette.text.disabled
  },
  addActionMenuIcon: {
    fontSize: 20,
    color: theme.palette.text.primary
  },
  jobTabs: {
    minHeight: 36,
    marginBottom: theme.spacing(2)
  },
  jobTab: {
    minHeight: 36,
    // ...theme.typography.subtitle2,
    fontWeight: theme.typography.fontWeightMedium,
    textTransform: 'none',
    minWidth: 'auto',
    padding: theme.spacing(0.75, 0)
  }
}))
